import { Loading } from '@lib/components'
import { ArrowDownThin, UploadThin } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useRef, useState } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  loading: boolean
  error: string
  onSelectFile: (file: File) => void
}

export const DropFile: React.FC<Props> = ({ loading, error, onSelectFile }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [dragActive, setDragActive] = useState(false)

  const onOpenFilePicker = () => {
    if (loading) {
      return
    }

    inputRef.current?.click()
  }

  const onDropHandle = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    setDragActive(false)

    const droppedFile = event.dataTransfer.files?.[0]

    if (!droppedFile) {
      return
    }

    onSelectFile(droppedFile)
  }

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file) {
      onSelectFile(file)
    }
  }

  const dropzoneCn = clsJoin(
    css.dropzone,
    dragActive && css.drag_active,
    Boolean(error) && css.error,
    loading && css.loading
  )

  return (
    <div
      className={dropzoneCn}
      onClick={onOpenFilePicker}
      onDrop={onDropHandle}
      onDragOver={(event) => {
        event.preventDefault()
        setDragActive(true)
      }}
      onDragLeave={(event) => {
        event.preventDefault()
        setDragActive(false)
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".xml,text/xml,application/xml"
        className={css.file_input}
        onChange={handleOnChange}
      />

      {loading && (
        <div className={css.loading_state}>
          <Loading type="medium" color="default" />
        </div>
      )}

      {dragActive && <ArrowDownThin className={css.load_active_icon} />}

      {!loading && !dragActive && (
        <div className={css.empty_state}>
          <UploadThin className={css.upload_icon} />
          <div className={css.empty_text}>
            Drop XML file here or click to upload
          </div>
        </div>
      )}
    </div>
  )
}
